<template>
<!-- <transition name="home"> -->
  <div class="home">
    <!-- <Header>
      <div slot="center">淘宝</div>
    </Header> -->
    <div class="t_banner">
      <img src="@/assets/banner2.png" alt="">
      <div class="input" @click="toSearch">
        <van-icon name="search" size="1.3rem" />
        搜索商品名或粘贴宝贝标题
      </div>
    </div>
    <div class="bar">
      <div  @click="toCategory(7)">
        <img src="@/assets/taobao1.png" alt="">
        <div>火爆朋友圈</div>
      </div>
      <!-- <div>
        <img src="@/assets/taobao2.png" alt="">
        <div>9.9</div>
      </div> -->
      <div  @click="toCategory(3)">
        <img src="@/assets/taobao4.png" alt="">
        <div>猫超</div>
      </div>
      <div @click="toCategory(8)">
        <img src="@/assets/taobao3.png" alt="">
        <div>销量榜</div>
      </div>
      <div @click="toCategory(5)">
        <img src="@/assets/taobao5.png" alt="">
        <div>品牌库</div>
      </div>
      <div @click="toCategory(1)">
        <img src="@/assets/taobao6.png" alt="">
        <div>高佣券</div>
      </div>
    </div>
    <!-- 每日必更 -->
    <div class="category">
      <div class="category_bar">
        <div class="category_item">
          <div class="title">每日必更·<span style="font-weight:400;">优选好物</span></div>
          <div class="content">
            <span class="c_item"  @click="toCategory(2)">
              <div class="text">
                9.9超值购
                <div class="c_btn">包邮</div>
                <span>上新1000款+</span>
              </div>
              <!-- style="border-right: solid 1px rgb(220, 220, 220);" -->
              <div  class="img" >
                <img src="@/assets/首页/class2.png" alt="">
              </div>
            </span>
            <span class="c_item" @click="toCategory(4)">
              <div class="text">
                聚划算
                <div class="c_btn">爆款</div>
                <span>领券购物更省</span>
              </div>
              <div class="img">
                <img src="@/assets/首页/class8.png" alt="">
              </div>
            </span>
          </div>
        </div>

        <div class="category_item" style="border:0;margin-top:4vw;">
          <div class="title">超值好物·<span style="font-weight:400;">等你来领</span></div>
          <div class="class_content">
            <div class="class_item" @click="toCategory(0,3)">
              <img src="@/assets/首页/class1.png" alt="">
              <div>时尚美妆</div>
            </div>
            <div class="class_item" @click="toCategory(0,1)">
              <img src="@/assets/首页/class3.png" alt="">
              <div>时尚女装</div>
            </div>
            <div class="class_item" @click="toCategory(0,11)">
              <img src="@/assets/首页/class4.png" alt="">
              <div>时尚箱包</div>
            </div>            
          </div>
          <div class="class_content">
            <div class="class_item" @click="toCategory(0,6)">
              <img src="@/assets/首页/class5.png" alt="">
              <div>休闲零食</div>
            </div>
            <div class="class_item" @click="toCategory(0,2)">
              <img src="@/assets/首页/class6.png" alt="">
              <div>品牌母婴</div>
            </div>
            <div class="class_item" @click="toCategory(0,8)">
              <img src="@/assets/首页/class7.png" alt="">
              <div>数码科技</div>
            </div>            
          </div>
        </div>
        <div class="category_item" style="margin:10px 0;border:0;">
          <div class="title">猜你喜欢</div>
        </div>
      </div>


    </div>
    <Nav></Nav>

    <TwoColumns></TwoColumns>
    
  </div>
<!-- </transition> -->
</template>

<script>
import Nav from "@/components/Nav/index";
import Header from "@/components/Header/index";
import html2canvas from 'html2canvas'
import axios from 'axios'
// import { goodsGuessLike } from "@/api/tb";
import TwoColumns from "@/components/TwoColumns/index";
import { getScrollParent } from "@/utils/common";

export default {

  components:{
    Nav,Header,html2canvas,TwoColumns
  },
  data(){
    return{
      goods_list:[],
      imgUrl:'',
      dialogVisible: false
    }
  },
  // computed: {
  //   userId(){
  //     return this.$store.state.userId
  //   }
  // },
  // watch: {
  //   userId(val) {
  //     if(val!==''){
  //       goodsGuessLike({userId:val}).then(res=>{
  //         this.goods_list = res.data
  //       })
  //     }
  //   }
  // },
  // activated () {
  //   console.log(123);
  // },
  // beforeRouteLeave(to, from, next){ 
  //   getScrollParent(window)
  //   next()
  // },
  methods: {
    // toDetail(no){
    //   this.$router.push('/detail?id='+no)
    // },
    toSearch(){
      this.$router.push('/search')
    },
    toCategory(type,cid){
      if(cid){
        this.$router.push('/category?cid='+cid)
      }else{
        this.$router.push('/category?type='+type)
      }
      
    }


  }
}
</script>

<style lang="less" scoped>
/* zoom */
.home-enter-active{
  opacity:1;
  transition: all .6s ease;  
}
.home-enter
 {
  opacity: 0.2;

}
.dialog{
  background-color: rgba(0,0,0,.6);
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99998;
  .content{
    position: absolute;
    width: 90vw;
    height: 90vh;
    top: 5vh;
    left: 5vw;
    z-index: 99999;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
.home{

  margin-bottom: 5.2rem;
  #canvasPic{
    width: 100vw;
    position: relative;
    margin-left: 0;
    img{
      width: 100%;
    }
    .test{
      position: absolute;
      bottom: 11rem;
      left: 17rem;
      z-index: 99;
      img{
        width: 3rem;
        height: 3rem;
      }

        z-index: 9999;
    }
  .QR_code{
    width: 100vw;
    img{
      width: 11.8rem;
      height: 11.8rem;
    }
    position: absolute;
    bottom: 6.6rem;
    display: flex;
    justify-content: center;


  }
  }

  .t_banner{
    box-sizing: border-box;
    position: relative;
    img{
      width: 100vw;
      height: 18rem;
    }

    .input{
      width: 80vw;
      height: 3.6rem;
      background-color: #fff;
      position: absolute;
      top:8.5rem;
      left: 10vw;
      border-radius: 6px;
      color: rgba(200,200,200,0.7);
      font-size: 1.3rem;
      i{
        color: rgba(200,200,200,1);
      }
      line-height: 3.6rem;
      text-align: center;
    }
  }
  .bar{
    width: 100vw;
    height: 8rem;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #fff;
    text-align: center;
    font-size: 1rem;
    padding: 10px;
    box-sizing: border-box;
    color: #666666;
    div{
      width: calc(96vw / 6);
    }
    img{
      width: 3.6rem;
      height: 3.6rem;
      margin-bottom: 4px;

    }
  }
  .category{
    box-sizing: border-box;
    width: 100vw;
    background-color: #fff;
    height: 46.7rem;
    .category_bar{
      box-sizing: border-box;
      width: 96vw;
      height: 43rem;
      margin-left: 2vw;
      border: solid 1px rgb(200, 200, 200);
      border-radius: 4px;
      padding: 1rem;
      .category_item{
        border-bottom: solid 1px rgb(220, 220, 220);
        padding:  0.4rem 0rem 1.4rem 0rem;
        .title{
          
          color: rgb(245, 60, 60);
          font-size: 1.6rem;
          font-weight: 600;
        }
        .content{
          display: flex;
          justify-content: space-around;
          margin-top: 2rem;
          width: 90vw;
          box-sizing: border-box;
          .c_item{
            display: flex;
            width: 45vw;
            // margin:0 1rem;
            // box-sizing: border-box;
            justify-content: space-around;
            font-size: 1.3rem;
            font-weight: 600;
            align-items: center;
            .text{
              width: 20vw;
              text-align: right;
              span{
                color: rgb(150, 150, 150);
                font-size: 1rem;
                font-weight: normal;
              }
            }
            .img{
              height: 9rem;
              width: 7rem;
              margin-left: 1.4rem;
              img{
                width: 100%;
                height: 100%;
              }
            }
            width: 50vw;
          }
          .c_btn{
            text-align: center;
            font-size: 1.2rem;
            font-weight: normal;
            width: 3.6rem;
            color: rgb(245, 60, 60);
            border-radius: 6px;
            border: rgb(245, 60, 60) solid 1px;
            // padding: 1px;
            height: 1.4rem;
            line-height: 1.5rem;
            margin: 1rem 0 1.6rem 3.5rem;
            
          }
        }
        .class_content{
          display: flex;
          justify-content: space-around;
          font-size: 1.5rem;
          text-align: center;
          img{
            margin-top: 10px;
            width: 9.7rem;
            height: 8.7rem;
          }
        }
      }
    }
  }
}
</style>